var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-5c2e5eab\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Home.en.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/i18n/views/Home.en.vue
// module id = 436
// module chunks = 0